/* __next_internal_client_entry_do_not_use__ SearchInput auto */ import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import * as React from "react";
import styled from "styled-components";
import { Close } from "../icons/foundation/Close";
import { Search } from "../icons/foundation/Search";
import { Input } from "../Input";
import { Spacer } from "../spacing";
import { HIGH_VIS_FILTER, highVisSlateComponent } from "../utils/highVisSlateComponent";
var Wrapper = styled.div.withConfig({
    componentId: "sc-a61ad29b-0"
})([
    "position:relative;",
    ""
], highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
var SearchWrapper = styled.div.withConfig({
    componentId: "sc-a61ad29b-1"
})([
    "pointer-events:none;display:flex;font-size:16px;"
]);
/**
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/IconButton/IconButton#IconButton"
 */ var CloseWrapper = styled.button.withConfig({
    componentId: "sc-a61ad29b-2"
})([
    "font-size:16px;display:flex;align-items:center;justify-content:center;"
]);
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/component/input/web/search-input)
 */ export var SearchInput = function(_param) {
    var autoComplete = _param.autoComplete, autoFocus = _param.autoFocus, onChange = _param.onChange, value = _param.value, className = _param.className, placeholder = _param.placeholder, onFocus = _param.onFocus, onBlur = _param.onBlur, onKeyUp = _param.onKeyUp, onKeyDown = _param.onKeyDown, id = _param.id, disabled = _param.disabled, label = _param.label, loading = _param.loading, title = _param.title, dataHjAllow = _param["data-hj-allow"], maxLength = _param.maxLength, props = _object_without_properties(_param, [
        "autoComplete",
        "autoFocus",
        "onChange",
        "value",
        "className",
        "placeholder",
        "onFocus",
        "onBlur",
        "onKeyUp",
        "onKeyDown",
        "id",
        "disabled",
        "label",
        "loading",
        "title",
        "data-hj-allow",
        "maxLength"
    ]);
    var ref = React.useRef(null);
    var onClear = function() {
        var _ref_current;
        props.onClear();
        (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    };
    var renderSuffixNode = function() {
        if (loading) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSpinner, {
                        size: "small",
                        color: Core.icon.subdued
                    })
                ]
            });
        } else if (value) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(CloseWrapper, {
                        onClick: onClear,
                        children: /*#__PURE__*/ _jsx(Close, {
                            color: Core.icon.subdued
                        })
                    })
                ]
            });
        } else {
            return null;
        }
    };
    return /*#__PURE__*/ _jsx(Wrapper, {
        className: className,
        children: /*#__PURE__*/ _jsx(StyledInput, {
            disabled: disabled,
            id: id,
            "data-test-id": props["data-test-id"],
            onChange: onChange,
            value: value,
            placeholder: placeholder,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyUp: onKeyUp,
            onKeyDown: onKeyDown,
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            prefixNode: /*#__PURE__*/ _jsx(SearchWrapper, {
                children: /*#__PURE__*/ _jsx(Search, {
                    color: Core.icon.default
                })
            }),
            suffixNode: renderSuffixNode(),
            ref: ref,
            label: label,
            title: title,
            "data-hj-allow": dataHjAllow,
            isButton: false,
            maxLength: maxLength
        })
    });
};
var StyledInput = styled(Input).withConfig({
    componentId: "sc-a61ad29b-3"
})([
    "input{margin-top:-2px;}"
]);
